import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { RechnerPage } from './pages/RechnerPage';
import { AppPage } from './pages/AppPage';
import { BeratungPage } from './pages/BeratungPage';
import { UeberUnsPage } from './pages/UeberUnsPage';
import { FAQPage } from './pages/FAQPage';
import { KontaktPage } from './pages/KontaktPage';
import { BlogPage } from './pages/BlogPage';
import { BlogArticlePage } from './pages/BlogArticlePage';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [pageData, setPageData] = useState<any>(null);
  // Enhanced navigation that supports passing data (e.g., article slug)
  const handleNavigate = (page: string, data?: any) => {
    setCurrentPage(page);
    setPageData(data || null);
  };
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage onNavigate={handleNavigate} data-id="element-0" />;
      case 'rechner':
        return <RechnerPage onNavigate={handleNavigate} data-id="element-1" />;
      case 'app':
        return <AppPage onNavigate={handleNavigate} data-id="element-2" />;
      case 'beratung':
        return <BeratungPage onNavigate={handleNavigate} data-id="element-3" />;
      case 'ueber-uns':
        return <UeberUnsPage onNavigate={handleNavigate} data-id="element-4" />;
      case 'faq':
        return <FAQPage onNavigate={handleNavigate} data-id="element-5" />;
      case 'kontakt':
        return <KontaktPage onNavigate={handleNavigate} data-id="element-6" />;
      case 'blog':
        return <BlogPage onNavigate={handleNavigate} data-id="element-7" />;
      case 'blog-article':
        return <BlogArticlePage slug={pageData?.slug || ''} onNavigate={handleNavigate} data-id="element-8" />;
      default:
        return <HomePage onNavigate={handleNavigate} data-id="element-9" />;
    }
  };
  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);
  return <div className="min-h-screen bg-white dark:bg-slate-950 font-sans text-slate-900 dark:text-slate-100 antialiased transition-colors duration-300" data-id="element-10">
      <Navbar currentPage={currentPage} onNavigate={handleNavigate} data-id="element-11" />
      <main data-id="element-12">{renderPage()}</main>
      <Footer onNavigate={handleNavigate} data-id="element-13" />
    </div>;
}